define.alias("shared/components/shared/enterprise-modal", "media/components/shared/enterprise-modal");